import { STATUS_NOTIFICATION_DEFAULT } from './constants';

export const getInitialState = () => ({
  error: undefined,
  dataSubscriptions: {
    list: [],
    mailSkyId: null,
  },
  isWidgetLoading: true,
  isMutationPending: false,
  statusNotification: STATUS_NOTIFICATION_DEFAULT,
  selectedOptionsIds: [],
  showUnsubscribeModal: false,
  showNewslettersFullScreen: false,
});
